export default {"src":"/_next/static/media/positionOpposition.01c5ee4f.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};